import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

// Generic ActionCable subscription controller for DataUpdatesChannel
// Subscribes on connect, unsubscribes on disconnect (Turbo-safe)
// Dispatches filtered messages as custom events for Alpine to handle
//
// Usage (single type):
//   <div data-controller="data-subscription"
//        data-data-subscription-type-value="inspection"
//        data-data-subscription-property-id-value="123"
//        @data-subscription:message.window="handleUpdate($event.detail)">
//
// Usage (multiple types):
//   <div data-controller="data-subscription"
//        data-data-subscription-types-value="meter_reading,meter"
//        data-data-subscription-property-id-value="123"
//        @data-subscription:message.window="handleUpdate($event.detail)">
//
export default class extends Controller {
  static values = {
    type: String,        // Single message type to filter (e.g., "inspection", "certificate", "meter_reading")
    types: String,       // Comma-separated list of message types to filter (e.g., "meter_reading,meter")
    propertyId: Number   // Property ID to filter messages for
  }

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "DataUpdatesChannel" },
      {
        received: (message) => this.handleMessage(message)
      }
    )
  }

  disconnect() {
    this.subscription?.unsubscribe()
  }

  handleMessage(message) {
    // Filter by message type(s)
    if (this.hasTypesValue) {
      // Multiple types specified as comma-separated string
      const allowedTypes = this.typesValue.split(',').map(t => t.trim())
      if (!allowedTypes.includes(message.type)) {
        return
      }
    } else if (this.hasTypeValue && message.type !== this.typeValue) {
      // Single type specified
      return
    }

    // Filter by property ID if specified
    if (this.hasPropertyIdValue) {
      const messagePropertyId = message.data?.property_id ||
                                message.data?.property?.id ||
                                message.data?.meter?.property_id

      if (messagePropertyId !== this.propertyIdValue) {
        return
      }
    }

    // Dispatch event for Alpine to handle
    this.dispatch("message", { detail: message })
  }
}
